import { Contact } from '../../modules/contacts/models/contacts.types';

export const contactsMock: Contact[] | any[] = [
  {
    id: 'e133245d-2065-4aec-ba80-73dba975af01',
    avatar: {
      id: 'e7a59b5b-45ce-4477-997f-12c21ac9de5f',
      url: 'https://files.pengueen.de/api/download/c5449ee2-b2e8-475f-a49a-5539c2d528bd.jpg',
    },
    invitor: true,
    nickname: null,
    state: 'INDIRECT',
    language: 'Deutsch',
    birthday: '01.12.2000',
    connection: 'COMMUNITY',
    email: 'pengueen@gmail.com',
    first_name: 'Admin',
    last_name: 'Pengueen',
    phone: '+4915172611407',
    role: 'GUEST',
    address: {
      country: 'de',
      street: 'Flemmingstraße',
      house_number: '32',
      place: 'Berlin',
      zip_code: '12555',
    },
    sort: 1,
  },
  {
    id: 'bfc368a0-2da5-4bb3-a6c2-50884e2e629c',
    avatar: null,
    invitor: true,
    nickname: null,
    state: 'INDIRECT',
    language: 'Deutsch',
    birthday: '01.12.2000',
    connection: 'COMMUNITY',
    email: 'stefanie@rendel.de',
    first_name: 'Stefanie',
    last_name: 'Rendel ',
    phone: null,
    role: 'GUEST',
    address: {
      country: null,
      street: null,
      house_number: null,
      place: null,
      zip_code: null,
    },
    sort: 2,
  },
  {
    id: 'ae4bdb65-43bb-4ad4-9810-49a28ac64a01',
    avatar: {
      id: 'e0fcf44f-2912-4bc2-946b-9bcb5dcdb996',
      url: 'https://files.pengueen.de/api/download/97f88503-f8d6-4b9b-ae3c-9c527b79276a.jpg',
    },
    invitor: true,
    nickname: null,
    state: 'INDIRECT',
    language: 'Deutsch',
    birthday: '01.12.2000',
    connection: 'COMMUNITY',
    email: 'daniel.dziamski@pengueen.de',
    first_name: 'Daniel',
    last_name: 'Dziamski',
    phone: null,
    role: 'GUEST',
    address: {
      country: null,
      street: null,
      house_number: null,
      place: null,
      zip_code: null,
    },
    sort: 3,
  },
  {
    id: '957b0cd6-c302-474d-a748-a269f16057ad',
    avatar: {
      id: '6589b8c6-85a5-4ec7-a470-f15bcde077ce',
      url: 'https://files.pengueen.de/api/download/ed762006-b0d7-4058-ae1c-ad1c0b4b2a21.jpg',
    },
    invitor: true,
    nickname: null,
    state: 'INDIRECT',
    language: 'Deutsch',
    birthday: '01.12.2000',
    connection: 'COMMUNITY',
    email: 'miriam.leiberich@posteo.de',
    first_name: 'Miriam',
    last_name: 'Leiberich',
    phone: null,
    role: 'GUEST',
    address: {
      country: null,
      street: null,
      house_number: null,
      place: null,
      zip_code: null,
    },
    sort: 4,
  },
  {
    id: '841ba1e1-565e-4623-aebe-848b9a75d114',
    avatar: {
      id: 'f5952654-8886-49d0-b82e-6b4c6b5bc5c9',
      url: 'https://files.pengueen.de/api/download/f17f0785-868a-4a9b-bd3f-5ac60318b3b6.png',
    },
    invitor: true,
    nickname: null,
    state: 'INDIRECT',
    language: 'Deutsch',
    birthday: '01.12.2000',
    connection: 'COMMUNITY',
    email: 'hjqueeen@gmail.com',
    first_name: 'Hyejin',
    last_name: 'Kim',
    phone: null,
    role: 'GUEST',
    address: {
      country: null,
      street: null,
      house_number: null,
      place: null,
      zip_code: null,
    },
    sort: 5,
  },
  {
    id: '0b419c75-042a-41fb-9fe2-89ff60f31634',
    avatar: null,
    invitor: true,
    nickname: null,
    state: 'INDIRECT',
    language: 'Deutsch',
    birthday: '01.12.2000',
    connection: 'COMMUNITY',
    email: 'schroeder.justus@outlook.de',
    first_name: 'Justus',
    last_name: 'Schröder',
    phone: null,
    role: 'GUEST',
    address: {
      country: null,
      street: null,
      house_number: null,
      place: null,
      zip_code: null,
    },
    sort: 6,
  },
];

export const contactsWithExtraColumns = {
  contacts: [
    {
      id: '8f68203a-84d7-402e-9eee-c6dd07e2f4eb',
      avatar: null,
      invitor: true,
      nickname: null,
      state: 'INDIRECT',
      connection: 'COMMUNITY',
      email: 'misch-mit@marburg-biedenkopf.de',
      first_name: 'Misch',
      last_name: 'Mit',
      phone: null,
      role: 'GUEST',
      language: 'Deutsch',
      birthday: '01.12.2000',
      address: {
        country: null,
        street: null,
        house_number: null,
        place: null,
        zip_code: null,
      },
      tool_informations: [],
      sort: 1,
    },
    {
      id: '6af8d9b5-fdde-4e2d-a72b-ac22b923d1db',
      avatar: null,
      invitor: true,
      nickname: null,
      state: 'INDIRECT',
      connection: 'COMMUNITY',
      email: 'bewerbung-dolma@marburg-biedenkopf.de',
      first_name: 'Test',
      last_name: 'Dolmetscherin',
      phone: null,
      role: 'GUEST',
      language: 'Englisch',
      birthday: '11.10.2012',
      address: {
        country: 'de',
        street: 'Test-Str.',
        house_number: '12',
        place: 'Marburg',
        zip_code: '35037',
      },
      tool_informations: [
        {
          id: '974f9e93-dfb5-4264-92c6-1eb18aa5ba23',
          name: '9/12/2023, 11:40:19 AM',
          description: 'Sprache',
          information: 'Englisch, Französisch',
        },
        {
          id: '974f9e93-dfb5-4264-92c6-1eb18aa5ba23',
          name: '9/12/2023, 11:40:19 AM',
          description: 'Verfügbarkeit',
          information: 'Mo bis Freitag, von 8 bis 14 Uhr',
        },
        {
          id: '974f9e93-dfb5-4264-92c6-1eb18aa5ba23',
          name: '9/12/2023, 11:40:19 AM',
          description: 'Anmerkung',
          information: '',
        },
        {
          id: '974f9e93-dfb5-4264-92c6-1eb18aa5ba23',
          name: '9/12/2023, 11:40:19 AM',
          description: 'Auto vorhanden?',
          information: 'Ja',
        },
        {
          id: '974f9e93-dfb5-4264-92c6-1eb18aa5ba23',
          name: '9/12/2023, 11:40:19 AM',
          description: 'Schriftliche Übersetzung?',
          information: '',
        },
      ],
      sort: 2,
    },
    {
      id: '4295a6a6-254b-4150-927c-2b7a4eb24bfa',
      avatar: null,
      invitor: true,
      nickname: null,
      state: 'INDIRECT',
      connection: 'COMMUNITY',
      email: 'dolma@marburg-biedenkopf.de',
      first_name: 'DolMa',
      last_name: null,
      phone: null,
      role: 'GUEST',
      language: 'Deutsch',
      birthday: '01.12.2000',
      address: {
        country: null,
        street: null,
        house_number: null,
        place: null,
        zip_code: null,
      },
      tool_informations: [],
      sort: 3,
    },
  ],
  community: {
    id: '3dd88303-175a-4804-9c89-2a747c8cf905',
    name: 'DolMa',
    avatar: {
      id: '650e2289-5359-4920-a4e1-3f7d72eee064',
      url: 'https://files.pengueen.de/api/download/9c406e6c-edc2-498b-8bc1-1a88124643fe.png',
    },
    selected_group: {
      id: '61327d89-dea4-4567-92dc-f2ac8ea8453b',
      creator_id: {
        id: '4295a6a6-254b-4150-927c-2b7a4eb24bfa',
        avatar_id: null,
        notifications_id: null,
        theme: 'Dark',
        email: 'dolma@marburg-biedenkopf.de',
        email_for_public: null,
        roles: ['user'],
        language: 'de',
        address_all: null,
        sms_factor: null,
        first_name: 'DolMa',
        last_name: null,
        birthday: null,
        street: null,
        house_number: null,
        zip_code: null,
        place: null,
        country: null,
        phone: null,
        phone_for_public: null,
        telephone: null,
        last_logout: '2024-08-22T10:14:34.952Z',
        last_login: '2024-08-22T10:10:44.602Z',
        previous_login: '2024-06-05T12:21:51.035Z',
        register_date: null,
        security_word: null,
        ghostAccount: null,
        blocked_users: '["a1362b74-2906-4b4b-87fc-ae807214cdf1"]',
        delete_date: null,
      },
      description: 'DolMa-Schulungsgruppe 2023',
      type: 'GROUP',
      name: 'DolMa Schulung 2023',
      inactive_room: null,
      tool_id: null,
      row_id: null,
      create_change_id: '0bdf95c4-901b-43d2-9879-94b445f434cc',
      connected_tool: null,
      room_has_msgs: true,
      no_include_creator: false,
      invite_link: null,
      participant: [
        {
          id: '8f68203a-84d7-402e-9eee-c6dd07e2f4eb',
          avatar_id: null,
          notifications_id: null,
          theme: null,
          email: 'misch-mit@marburg-biedenkopf.de',
          email_for_public: null,
          roles: ['user'],
          language: 'de',
          address_all: null,
          sms_factor: null,
          first_name: 'Misch',
          last_name: 'Mit',
          birthday: null,
          street: null,
          house_number: null,
          zip_code: null,
          place: null,
          country: null,
          phone: null,
          phone_for_public: null,
          telephone: null,
          last_logout: '2024-02-05T17:22:13.063Z',
          last_login: '2024-02-05T17:21:18.460Z',
          previous_login: '2024-02-02T12:12:09.714Z',
          register_date: null,
          security_word: null,
          ghostAccount: null,
          blocked_users: null,
          delete_date: null,
        },
        {
          id: '6af8d9b5-fdde-4e2d-a72b-ac22b923d1db',
          avatar_id: null,
          notifications_id: null,
          theme: null,
          email: 'bewerbung-dolma@marburg-biedenkopf.de',
          email_for_public: null,
          roles: ['user'],
          language: 'de',
          address_all: null,
          sms_factor: null,
          first_name: 'Test',
          last_name: 'Dolmetscherin',
          birthday: null,
          street: 'Test-Str.',
          house_number: '12',
          zip_code: '35037',
          place: 'Marburg',
          country: 'de',
          phone: null,
          phone_for_public: null,
          telephone: '0150 0000000',
          last_logout: '2024-03-08T12:13:06.315Z',
          last_login: '2024-03-08T12:01:16.387Z',
          previous_login: '2024-03-08T08:24:53.544Z',
          register_date: null,
          security_word: null,
          ghostAccount: null,
          blocked_users: null,
          delete_date: null,
        },
        {
          id: '4295a6a6-254b-4150-927c-2b7a4eb24bfa',
          avatar_id: null,
          notifications_id: null,
          theme: 'Dark',
          email: 'dolma@marburg-biedenkopf.de',
          email_for_public: null,
          roles: ['user'],
          language: 'de',
          address_all: null,
          sms_factor: null,
          first_name: 'DolMa',
          last_name: null,
          birthday: null,
          street: null,
          house_number: null,
          zip_code: null,
          place: null,
          country: null,
          phone: null,
          phone_for_public: null,
          telephone: null,
          last_logout: '2024-08-22T10:14:34.952Z',
          last_login: '2024-08-22T10:10:44.602Z',
          previous_login: '2024-06-05T12:21:51.035Z',
          register_date: null,
          security_word: null,
          ghostAccount: null,
          blocked_users: '["a1362b74-2906-4b4b-87fc-ae807214cdf1"]',
          delete_date: null,
        },
      ],
      favorite_user: [],
      tags: [],
      inactive_users: [],
      community_id: {
        id: '3dd88303-175a-4804-9c89-2a747c8cf905',
        address_id: 'cc4894cc-a9b4-4e71-8134-a988d461587f',
        contact_id: '2daafcb2-1656-44b2-87c7-8d90d6672fea',
        logo: '650e2289-5359-4920-a4e1-3f7d72eee064',
        name: 'DolMa',
        favorite: null,
        widget_text: '<p></p>',
        sector: null,
        groups: null,
        create_change_id: '6c1576ae-cd53-468a-9d83-1009cf23d4f4',
        invoice_address: '29172398-8483-4aa8-bdec-6c2c030ce137',
        license: '9182ec92-eb39-4943-9e7e-b35a023d6d14',
        member_string: '',
        employee_string: 'Koordinierungsstelle',
        link: null,
        betreff_einladung_email:
          'Du wurdest auf der Plattform Pengueen eingeladen',
        headline_einladung_email: 'Du wurdest zu Pengueen eingeladen.',
        text_einladung_email:
          '<p>{EinladenerNutzer} hat dich zu Pengueen eingeladen. Schön, dich kennenzulernen!</p>',
        text_einladung_bestaetigung_email:
          '<p>Hallo!</p><p><br></p><p>Glückwunsch zu deinem Pengueen-Konto und einen weiteren Schritt, um einfach zu digitalisieren. 😃</p>',
        betreff_einladung_bestaetigung_email:
          'Du hast dich auf unserer Plattform Pengueen registriert',
        show_name_formular_at_registration: true,
        admin_link: null,
        employee_link: null,
        member_link: null,
        admins: [
          {
            id: '2daafcb2-1656-44b2-87c7-8d90d6672fea',
            avatar_id: null,
            notifications_id: null,
            theme: 'Light',
            email: 'leiberichm@marburg-biedenkopf.de',
            email_for_public: null,
            roles: ['user'],
            language: 'de',
            address_all: null,
            sms_factor: null,
            first_name: 'Miriam',
            last_name: 'Leiberich',
            birthday: null,
            street: 'Marktstraße',
            house_number: '6',
            zip_code: '35260',
            place: 'Stadtallendorf',
            country: 'de',
            phone: '00491707690603',
            phone_for_public: null,
            telephone: '064284472216',
            last_logout: '2024-02-08T13:49:04.993Z',
            last_login: '2024-02-16T12:36:40.168Z',
            previous_login: '2024-02-12T06:18:53.354Z',
            register_date: null,
            security_word: null,
            ghostAccount: null,
            blocked_users: '["c6a659a5-3aba-4cc8-9094-3e5781570b01"]',
            delete_date: null,
          },
          {
            id: 'e133245d-2065-4aec-ba80-73dba975af01',
            avatar_id: 'e7a59b5b-45ce-4477-997f-12c21ac9de5f',
            notifications_id: null,
            theme: 'Light',
            email: 'pengueen@gmail.com',
            email_for_public: null,
            roles: ['user'],
            language: 'de',
            address_all: null,
            sms_factor: null,
            first_name: 'Admin',
            last_name: 'Pengueen',
            birthday: null,
            street: 'Flemmingstraße',
            house_number: '32',
            zip_code: '12555',
            place: 'Berlin',
            country: 'de',
            phone: '+4915172611407',
            phone_for_public: null,
            telephone: '015172611407',
            last_logout: '2024-12-11T09:37:22.670Z',
            last_login: '2025-04-24T04:30:27.448Z',
            previous_login: '2025-02-05T14:54:13.109Z',
            register_date: null,
            security_word: 'Pass2EnterPengueen',
            ghostAccount: null,
            blocked_users: '["957b0cd6-c302-474d-a748-a269f16057ad"]',
            delete_date: null,
          },
          {
            id: '2394352e-220a-4767-a432-26d641e3e8e5',
            avatar_id: null,
            notifications_id: null,
            theme: null,
            email: 'EngelhardtFr@marburg-biedenkopf.de',
            email_for_public: null,
            roles: ['user'],
            language: 'de',
            address_all: null,
            sms_factor: null,
            first_name: 'Franziska',
            last_name: 'Engelhardt',
            birthday: null,
            street: null,
            house_number: null,
            zip_code: null,
            place: null,
            country: null,
            phone: null,
            phone_for_public: null,
            telephone: null,
            last_logout: '2023-07-27T14:59:14.509Z',
            last_login: '2023-07-27T14:18:01.237Z',
            previous_login: '2023-07-24T10:11:10.031Z',
            register_date: null,
            security_word: null,
            ghostAccount: null,
            blocked_users: null,
            delete_date: null,
          },
          {
            id: '0bdf8778-5f48-4830-8dfc-25d43d5a39f1',
            avatar_id: null,
            notifications_id: null,
            theme: 'Dark',
            email: 'kurzs@marburg-biedenkopf.de',
            email_for_public: null,
            roles: ['user'],
            language: 'de',
            address_all: null,
            sms_factor: null,
            first_name: 'Sarah',
            last_name: 'Kurz',
            birthday: null,
            street: null,
            house_number: null,
            zip_code: null,
            place: null,
            country: null,
            phone: null,
            phone_for_public: null,
            telephone: null,
            last_logout: '2023-09-06T06:35:03.154Z',
            last_login: '2023-09-06T06:33:31.711Z',
            previous_login: '2023-09-05T11:21:16.833Z',
            register_date: null,
            security_word: null,
            ghostAccount: null,
            blocked_users: null,
            delete_date: null,
          },
          {
            id: '559ed17f-7718-4bbd-9390-df8c5c7121a0',
            avatar_id: null,
            notifications_id: null,
            theme: null,
            email: 'geskee@marburg-biedenkopf.de',
            email_for_public: null,
            roles: ['user'],
            language: 'de',
            address_all: null,
            sms_factor: null,
            first_name: 'Ellen',
            last_name: 'Geske',
            birthday: null,
            street: null,
            house_number: null,
            zip_code: null,
            place: null,
            country: null,
            phone: null,
            phone_for_public: null,
            telephone: null,
            last_logout: '2023-08-11T08:55:35.570Z',
            last_login: '2023-11-16T10:59:51.732Z',
            previous_login: '2023-09-06T06:22:17.681Z',
            register_date: null,
            security_word: null,
            ghostAccount: null,
            blocked_users: null,
            delete_date: null,
          },
          {
            id: '4295a6a6-254b-4150-927c-2b7a4eb24bfa',
            avatar_id: null,
            notifications_id: null,
            theme: 'Dark',
            email: 'dolma@marburg-biedenkopf.de',
            email_for_public: null,
            roles: ['user'],
            language: 'de',
            address_all: null,
            sms_factor: null,
            first_name: 'DolMa',
            last_name: null,
            birthday: null,
            street: null,
            house_number: null,
            zip_code: null,
            place: null,
            country: null,
            phone: null,
            phone_for_public: null,
            telephone: null,
            last_logout: '2024-08-22T10:14:34.952Z',
            last_login: '2024-08-22T10:10:44.602Z',
            previous_login: '2024-06-05T12:21:51.035Z',
            register_date: null,
            security_word: null,
            ghostAccount: null,
            blocked_users: '["a1362b74-2906-4b4b-87fc-ae807214cdf1"]',
            delete_date: null,
          },
          {
            id: '841ba1e1-565e-4623-aebe-848b9a75d114',
            avatar_id: 'f5952654-8886-49d0-b82e-6b4c6b5bc5c9',
            notifications_id: null,
            theme: 'Light',
            email: 'hjqueeen@gmail.com',
            email_for_public: 'hjqueeen123@gmail.com',
            roles: ['user'],
            language: 'de',
            address_all: 'Chamissostr. 10, 13587 Berlin',
            sms_factor: null,
            first_name: 'Hyejin',
            last_name: 'Kim',
            birthday: null,
            street: null,
            house_number: null,
            zip_code: null,
            place: null,
            country: null,
            phone: null,
            phone_for_public: null,
            telephone: null,
            last_logout: '2025-02-05T14:54:10.488Z',
            last_login: '2025-04-23T03:28:59.005Z',
            previous_login: '2025-04-23T03:27:17.966Z',
            register_date: null,
            security_word: 'my security word2',
            ghostAccount: null,
            blocked_users: '',
            delete_date: null,
          },
          {
            id: 'ae4bdb65-43bb-4ad4-9810-49a28ac64a01',
            avatar_id: 'e0fcf44f-2912-4bc2-946b-9bcb5dcdb996',
            notifications_id: null,
            theme: 'Light',
            email: 'daniel.dziamski@pengueen.de',
            email_for_public: null,
            roles: ['user'],
            language: 'de',
            address_all: null,
            sms_factor: null,
            first_name: 'Daniel',
            last_name: 'Dziamski',
            birthday: null,
            street: null,
            house_number: null,
            zip_code: null,
            place: null,
            country: null,
            phone: null,
            phone_for_public: null,
            telephone: null,
            last_logout: '2024-05-22T13:30:16.583Z',
            last_login: '2024-09-24T04:57:05.051Z',
            previous_login: '2024-09-23T05:07:18.936Z',
            register_date: null,
            security_word: null,
            ghostAccount: null,
            blocked_users: '["01f61a1a-a1f7-4318-9f0a-b5b28b86b269"]',
            delete_date: null,
          },
          {
            id: '560f4aab-7b6e-4a85-b4d2-6705779ecf09',
            avatar_id: null,
            notifications_id: null,
            theme: null,
            email: 'weinreichc@marburg-biedenkopf.de',
            email_for_public: null,
            roles: ['user'],
            language: 'de',
            address_all: null,
            sms_factor: null,
            first_name: 'Cornelia',
            last_name: 'Weinreich',
            birthday: null,
            street: null,
            house_number: null,
            zip_code: null,
            place: null,
            country: null,
            phone: null,
            phone_for_public: null,
            telephone: null,
            last_logout: '2024-09-23T11:14:14.403Z',
            last_login: '2024-09-23T11:08:30.854Z',
            previous_login: '2024-09-04T11:42:08.699Z',
            register_date: null,
            security_word: null,
            ghostAccount: null,
            blocked_users: null,
            delete_date: null,
          },
        ],
      },
      tools: [],
      favorite: false,
    },
    member_role: 'ADMIN',
    tools: [],
  },
  extraHeaders: [
    'Sprache',
    'Verfügbarkeit',
    'Anmerkung',
    'Auto vorhanden?',
    'Schriftliche Übersetzung?',
  ],
};
